import { IDropdownOption } from '@fluentui/react';
import { jobStatus } from './jobStatus';

export const jobStatusOptions: IDropdownOption[] = Object.entries(jobStatus).map(([key, text]) => ({ key: key + '', text }));